import { BASE_URI_LC } from '../../constants/ApiConstants';
import { quickFetchOrGet } from '../../utils/ajaxUtils';
import http from 'hub-http/clients/apiClient';
import dataFetchingClient from '../../utils/DataFetchingClient';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
export const GET_RECOMMENDATIONS = registerQuery({
  fieldName: 'recommendations',
  args: [],
  fetcher() {
    return quickFetchOrGet('recommendations', `${BASE_URI_LC}/recommendations/user`);
  }
});
export const getRecommendations = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_RECOMMENDATIONS
  });
};
export const useRecommendations = () => {
  const {
    data: recommendations,
    loading: recommendationsLoading,
    error: recommendationsError
  } = useQuery(GET_RECOMMENDATIONS);
  return {
    recommendations,
    recommendationsLoading,
    recommendationsError
  };
};
export const GET_RECOMMENDATIONS_TOPIC_PREFERENCE = registerQuery({
  fieldName: 'recommendationsTopicPreference',
  args: [],
  fetcher() {
    return quickFetchOrGet('topic-preferences', `${BASE_URI_LC}/recommendations/topic-preferences`);
  }
});
export const getRecommendationsTopicPreference = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_RECOMMENDATIONS_TOPIC_PREFERENCE
  });
};
export const useRecommendationsTopicPreference = () => {
  const {
    data: recommendationsTopicPreference,
    loading: recommendationsTopicPreferenceLoading,
    error: recommendationsTopicPreferenceError
  } = useQuery(GET_RECOMMENDATIONS_TOPIC_PREFERENCE);
  return {
    recommendationsTopicPreference,
    recommendationsTopicPreferenceLoading,
    recommendationsTopicPreferenceError
  };
};
export const GET_RECOMMENDATIONS_FOR_TRACK = registerQuery({
  fieldName: 'recommendationsForTrack',
  args: ['trackId'],
  fetcher({
    trackId
  }) {
    return http.get(`${BASE_URI_LC}/recommendations/track/${trackId}`);
  }
});
export const useRecommendationsForTrack = trackId => {
  const {
    data: recommendationsForTrack,
    loading: recommendationsForTrackLoading,
    error: recommendationsForTrackError
  } = useQuery(GET_RECOMMENDATIONS_FOR_TRACK, {
    variables: {
      trackId
    }
  });
  return {
    recommendationsForTrack,
    recommendationsForTrackLoading,
    recommendationsForTrackError
  };
};
export const GET_RECOMMENDATIONS_FOR_LESSON = registerQuery({
  fieldName: 'recommendationsForLesson',
  args: ['lessonId'],
  fetcher({
    lessonId
  }) {
    return http.get(`${BASE_URI_LC}/recommendations/lesson/${lessonId}`);
  }
});
export const useRecommendationsForLesson = lessonId => {
  const {
    data: recommendationsForLesson,
    loading: recommendationsForLessonLoading,
    error: recommendationsForLessonError
  } = useQuery(GET_RECOMMENDATIONS_FOR_LESSON, {
    variables: {
      lessonId
    }
  });
  return {
    recommendationsForLesson,
    recommendationsForLessonLoading,
    recommendationsForLessonError
  };
};